export default `${process.env.REACT_APP_BASE_API_URL}`;
